{
  "zh-TW": {
    "validations": {
      "required": "%{field} 欄位是必填的",
      "min": "%{field} 欄位至少需要 %{min} 個字元",
      "max": "%{field} 欄位最多 %{max} 個字元",
      "alpha_dash": "The %{field} field may contain alpha-numeric characters as well as dashes and underscores",
      "email": "%{field} 欄位必須是有效的電子郵件地址",
      "confirmed": "%{field} 欄位不符",
      "numeric": "%{field} 欄位只能包含數字",
      "between": "%{field} 欄位必須在 %{min} 和 %{max} 之間",
      "min_value": "%{field} 欄位必須為 %{min} 或更多",
      "url": "%{field} 欄位不是有效的 URL"
    }
  }
}
